import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import classNames from "classnames";
import Grid from "../../elements/Grid";
import BlockLink from "./components/BlockLink";
import Column from "./components/Column";
import Group from "./components/Group";
import Link from "./components/Link";

var ListOfLinks = function ListOfLinks(_ref) {
  var children = _ref.children,
      columns = _ref.columns,
      topBorder = _ref.topBorder;
  var getClassName = getClassNameFactory(ListOfLinks.displayName);
  var innerContent;
  var hasColumns = columns > 1;

  if (hasColumns) {
    innerContent = /*#__PURE__*/React.createElement(Grid, {
      gutterlessAtNarrow: true,
      variant: "even-".concat(columns)
    }, children);
  } else {
    innerContent = /*#__PURE__*/React.createElement("ul", {
      className: getClassName({
        descendantName: "items"
      })
    }, children);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames({
        topBorder: topBorder,
        hasColumns: hasColumns
      })
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, innerContent));
};

ListOfLinks.displayName = "ListOfLinks";
ListOfLinks.propTypes = {
  /**
   * Children to render. One of Link, BlockLink, Group or Column.
   */
  children: PropTypes.node,

  /**
   * Number of columns to render. Used in conjunction with Column children.
   */
  columns: PropTypes.oneOf([1, 2, 3]),
  // eslint-disable-line no-magic-numbers

  /**
   * Render an optional border at the top of the ListOfLinks.
   */
  topBorder: PropTypes.bool
};
ListOfLinks.defaultProps = {
  columns: 1,
  topBorder: false
};
ListOfLinks.BlockLink = BlockLink;
ListOfLinks.Column = Column;
ListOfLinks.Group = Group;
ListOfLinks.Link = Link;
export default ListOfLinks;